// fun little notifyer UI for prompting the user to switch to RFP view in mobile when the bot has made a change to the RFP
  export function activateRainbowRing() {
    const el = document.querySelector('.switch-views-button.chat');
    if (!el) {
      console.warn('No element found with class .switch-views-button.chat');
      return;
    }
    el.classList.add('rainbow-ring-active');
  }
  
  export function deactivateRainbowRing() {
    const el = document.querySelector('.switch-views-button.chat');
    if (!el) {
      console.warn('No element found with class .switch-views-button.chat');
      return;
    }
    el.classList.remove('rainbow-ring-active');
  }